export const FETCH_CATEGORY_API = '/products/genres/:id/details';
